import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/resources/$id/versions/$versionId")({
  staticData: {
    title: "versions.title",
  },
});
